import React, { memo } from 'react'
import { Email } from 'components/forms/Email'
import { makeStyles, Typography } from 'transfix-ui/core'
import { DISPLAY } from 'constants/display'
import { IShipperContact } from '../utils/normalizeShipperContacts'

const useEmailStyles = makeStyles(({ spacing }) => ({
  secondaryEmail: {
    whiteSpace: 'nowrap',
    '& a': {
      marginRight: spacing(0.5),
    },
  },
}))

export const ContactEmails = memo<Pick<IShipperContact, 'email' | 'secondaryEmail' | 'ediEmails'>>(
  ({ ediEmails, email, secondaryEmail }) => {
    const classes = useEmailStyles()
    return (
      <div>
        {ediEmails?.length ? (
          ediEmails.map(edi => (
            <div key={edi.email} className={classes.secondaryEmail}>
              <Typography variant='body1'>
                <Email email={edi.email} title={edi.email} />
                {edi.name && (
                  <Typography variant='caption' color='textSecondary'>
                    {edi.name}
                  </Typography>
                )}
              </Typography>
            </div>
          ))
        ) : (
          <Typography variant='body1'>
            {email ? <Email email={email} title={email} /> : DISPLAY.empty}
          </Typography>
        )}
        {secondaryEmail && (
          <div className={classes.secondaryEmail}>
            <Typography variant='body1'>
              <Email email={secondaryEmail} title={secondaryEmail} />
              <Typography variant='caption' color='textSecondary'>
                Secondary
              </Typography>
            </Typography>
          </div>
        )}
      </div>
    )
  }
)
